import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Title from './Title';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import jwt_decode from 'jwt-decode';
import { GetAuthTokenAsync } from './GetAuthToken';

interface DataTableProps {
  data: string[];
  onDelete: (itemName: string) => void;
}

const DataTable: React.FC<DataTableProps> = ({ data, onDelete }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [roleData, getUserRole] = useState<string[]>([]);

  useEffect(() => {
    fetchRoles();
  }, []);

  const itemsPerPage = 15;

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleDownload = (item: string) => {
    const win = window.open(`/contentdownload/content/${item}`, "_blank");
    win?.focus();
  };

  if (!data || data.length === 0) {
    return <div>No data to display</div>;
  }

  const filteredData = data.filter((item) =>
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleDelete = (itemName: string) => {
    confirmAlert({
      title: 'Confirm to delete',
      message: `Are you sure you want to delete ${itemName}?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => onDelete(itemName),
        },
        {
          label: 'No',
        }
      ]
    });
  };

  const fetchRoles = async () => {
    const token = await GetAuthTokenAsync();
    const decodeToken = jwt_decode(token);
    const roles = decodeToken['roles'];
    getUserRole(roles);
  };

  const deleteItem = (item: string) => {
    if(roleData.includes("carly.admin"))
    {
      deleteButton = <button onClick={() => handleDelete(item)}>Delete</button>;
    }
  };

  let deleteButton;

  return (
    <div>
      <Title/>
      <input
        type="text"
        placeholder="Search by name"
        value={searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: '1rem' }}
      />
      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #ddd', padding: '0.5rem' }}>
              Name
            </th>
            <th style={{ border: '1px solid #ddd', padding: '0.5rem' }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
  {paginatedData.map((item, index) => (
    <tr key={index}>
      <td style={{ border: '1px solid #ddd', padding: '0.5rem' }}>
        {item}
      </td>
      <td style={{ border: '1px solid #ddd', padding: '0.5rem' }}>
      <button onClick={() => handleDownload(item)}>Download</button>
      {deleteItem(item)}
      {deleteButton}
      </td>
    </tr>
  ))}
</tbody>
      </table>
      <div style={{ marginTop: '1rem' }}>
        {Array.from({ length: totalPages }, (_, index) => index + 1).map(
          (page) => (
            <button
              key={page}
              onClick={() => handlePageChange(page)}
              style={{
                marginRight: '0.5rem',
                padding: '0.5rem 1rem',
                border: '1px solid #ddd',
                backgroundColor: currentPage === page ? '#ddd' : 'transparent',
              }}
            >
              {page}
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default DataTable;
